import LazyImage from "./LazyImage";
import LazyVideo from "./LazyVideo";
import Router from "./Router";
import Signature from "./Signature";

export default new class Core {

    initRouter() { Router.init() }

    initLazyImage() { LazyImage.init() }
    
    initLazyVideo() { LazyVideo.init() }

    initSignature() { Signature.init() }

    init(){
        this.initSignature();
        this.initRouter();
        this.initLazyImage();
        this.initLazyVideo();
    }
}